import { Button, Card, InputAdornment, Stack, TextField } from "@mui/material";
import CustomBreadcrumbs from "../../../components/custom-breadcrumbs/custom-breadcrumbs";
import PageComponent from "../../../components/page";
import Iconify from "../../../components/iconify";
import { ChangeEvent } from "react";
import useSystemList from "./useList";
import SortByComponent from "../../../components/sort-by-component";
import { columnsSystemTable, systemOrderOptions } from "../../../constants/system";
import TableComponent from "../../../components/table";
import { ISystem } from "../../../types/system";
import SystemTableRowComponent from "./components/table-row";
import CreateSystemDialogComponent from "./components/dialog-create";
import useSystemUpdate from "./useUpdate";
import UpdateSystemDialogComponent from "./components/dialog-update";

const SystemPage = () => {

    const { loading, nameSystem, setNameSystem, table, systemsList, openCreateDialog, isSubmitting, methods, onSubmit, getSystems, activeSystem, deleteSystem } = useSystemList();
    const { loadingUpdate, methodsUpdate, onSubmitUpdate, openUpdateDialog, setValuesUpdate } = useSystemUpdate(getSystems, loading);

    return (
        <PageComponent>
            <>
                <CustomBreadcrumbs
                    heading="Sistemas"
                    links={[
                        {
                            name: 'Sistemas'
                        },
                        {
                            name: 'Lista'
                        }
                    ]}
                    action={
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon={'mingcute:add-line'} />}
                            onClick={openCreateDialog.onTrue}
                        >
                            Novo Sistema
                        </Button>
                    }
                    sx={{
                        mb: { sx: 3, md: 5 }
                    }}
                />

                <Stack
                    spacing={3}
                    justifyContent={'space-between'}
                    alignItems={{ xs: 'flex-end', md: 'center' }}
                    direction={{ xs: 'column', md: 'row' }}
                    sx={{ mb: { xs: 3, md: 5 } }}
                >
                    <TextField
                        placeholder="Pesquisar..."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon={"eva:search-fill"} sx={{ ml: 1, color: 'text.disabled' }} />
                                </InputAdornment>
                            )
                        }}
                        sx={{ width: { xs: 1, md: 260 } }}
                        value={nameSystem}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => setNameSystem(event.target.value)}
                    />
                    <SortByComponent
                        direction={table.direction}
                        onSort={table.onSort}
                        sortBy={table.sortBy}
                        sortOptions={systemOrderOptions}
                    />
                </Stack>
                <Card>
                    <TableComponent
                        headLabel={columnsSystemTable}
                        loading={loading.value}
                        table={table}
                        totalCount={systemsList?.totalCount ?? 0}
                    >
                        <>
                            {
                                systemsList?.data?.map((system: ISystem) => {
                                    return (
                                        <SystemTableRowComponent
                                            row={system}
                                            onDeleteRow={() => system.deletedAt ? activeSystem(system.id) : deleteSystem(system.id)}
                                            onEditRow={() => setValuesUpdate(system)}
                                            key={system.id}
                                        />
                                    )
                                })
                            }
                        </>
                    </TableComponent>
                </Card>

                <CreateSystemDialogComponent
                    isSubmitting={isSubmitting}
                    methods={methods}
                    onClose={openCreateDialog.onFalse}
                    onSubmit={onSubmit}
                    open={openCreateDialog.value}
                />

                <UpdateSystemDialogComponent
                    open={openUpdateDialog.value}
                    onClose={openUpdateDialog.onFalse}
                    isSubmitting={loadingUpdate.value}
                    methods={methodsUpdate}
                    onSubmit={onSubmitUpdate}
                />
            </>
        </PageComponent>
    )

}

export default SystemPage;